const iv = require('../config/iv');
const uniq = require('lodash/uniq');

function getAvailableIvCategories(caseConf, forcedKeys = []) {
  const categoryKeys = [];
  for (const ivType of caseConf.iv.types || []) {
    if (!ivType.sites || !ivType.sites.length) {
      continue;
    }
    categoryKeys.push(ivType.type);
  }
  for (const initialIv of caseConf.initialIvs || []) {
    categoryKeys.push(initialIv.categoryType);
  }
  for (const key of forcedKeys) {
    categoryKeys.push(key)
  }
  const allCategories = iv.categories.concat(iv.oasCategories);
  return uniq(categoryKeys).map(key => allCategories.find(cat => cat.key === key));
}

function getPortName(portNameKey, categoryType) {
  const portName = iv.portNames.find(pn => pn.key === portNameKey)
  return {
    key: portName.key,
    label: portName.categoryLabel && portName.categoryLabel[categoryType] ?
      portName.categoryLabel[categoryType] :
      portName.label
  };
}

function isOasCategory(categoryKey) {
  return categoryKey !== 'PERIPHERAL' && categoryKey !== 'INTRAOSSEOUS';
}

function getAvailableIvPorts(caseConf, forcedKeys = []) {
  const portNameList = [];
  // Look at IV setup
  for (const ivType of caseConf.iv.types || []) {
    if (!ivType.sites || !ivType.sites.length) {
      continue;
    }
    for (const portAmountKey of ivType.ports) {
      const portAmount = iv.portAmounts.find(pa => pa.key === portAmountKey);
      if (!portAmount) {
        continue;
      }
      for (const portKey of portAmount.defaultPorts || []) {
        portNameList.push(getPortName(portKey, ivType.type));
      }
    }
  }
  // Look at initial IVs
  for (const initialIv of caseConf.initialIvs || []) {
    const portAmountKey = initialIv.portAmount;
    const portAmount = iv.portAmounts.find(pa => pa.key === portAmountKey);
    if (!portAmount) {
      continue;
    }
    const { categoryType } = initialIv;
    if (!isOasCategory(categoryType)) {
      continue; // only consider OAS categories
    }
    const portList = portAmount.categoryPorts && portAmount.categoryPorts[categoryType] ?
      portAmount.categoryPorts[categoryType] : portAmount.defaultPorts;
    for (const portKey of portList) {
      portNameList.push(getPortName(portKey, categoryType));
    }
  }
  // Force ports to be available
  for (const key of forcedKeys) {
    portNameList.push(getPortName(key))
  }
  // Create map of key: [label]
  const portMap = {};
  for (const portInfo of portNameList) {
    if (!portMap[portInfo.key]) {
      portMap[portInfo.key] = [];
    }
    portMap[portInfo.key].push(portInfo.label.en);
  }
  return Object.entries(portMap).map(([key, labelList]) => {
    return {
      key,
      label: {
        en: uniq(labelList).join('/')
      }
    }
  });
}

function getAvailableIvSites(caseConf, forcedKeys = [], selectedCategories = []) {
  const locationKeys = [];
  for (const ivType of caseConf.iv.types || []) {
    if (!selectedCategories.length || selectedCategories.includes(ivType.type)) {
      for (const ivSite of ivType.sites || []) {
        locationKeys.push(ivSite.site)
      }
    }
  }
  for (const initialIv of caseConf.initialIvs || []) {
    if (isOasCategory(initialIv.categoryType)) {
      locationKeys.push(initialIv.site);
    }
  }
  for (const key of forcedKeys) {
    locationKeys.push(key)
  }
  return uniq(locationKeys).map(key => iv.sites.find(site => site.key === key));
}

function getAvailableIvSides(caseConf, forcedKeys = []) {
  const sideKeys = [];
  for (const ivType of caseConf.iv.types || []) {
    for (const ivSite of ivType.sites || []) {
      for (const ivSide of ivSite.sides || []) {
        sideKeys.push(ivSide);
      }
    }
  }
  for (const initialIv of caseConf.initialIvs || []) {
    if (isOasCategory(initialIv.categoryType)) {
      sideKeys.push(initialIv.side);
    }
  }
  for (const key of forcedKeys) {
    sideKeys.push(key)
  }
  return uniq(sideKeys).map(key => iv.sides.find(side => side.key === key));
}

module.exports = {
  getAvailableIvCategories,
  getAvailableIvPorts,
  getAvailableIvSites,
  getAvailableIvSides,
}